export enum CollabReportDisplayMode {
    Create,
    Readonly,
    Edit,
    Preview,
}